import { memo, useContext, useState } from 'react';

import { useCreateAnOrder } from './hooks';
import {
  ADD_FUNDS_TO_THE_WALLET_FORM,
  ADD_FUNDS_TO_THE_WALLET_STEPS,
  AddFundsOrderFilters,
  AddFundsToTheWalletOrder,
  AddFundsToTheWalletOrderResponse,
  PAYMENT_METHODS
} from './interfaces';
import { ClientBalanceContext } from '../clientBalanceContext';
import { AddingFundsOrderConfirmation, AddingFundsOrderForm, AddingFundsOrderSummary } from './steps';

interface Props {
  handleClose: () => void;
}

const AddFundsToYourWallet = ({ handleClose }: Props) => {
  const { updateCreditsHistory, updateClientBalance } = useContext(ClientBalanceContext);
  const { handleCreateAnOrder, createAnOrderLoading, createAnOrderError } = useCreateAnOrder();
  const [orderFormData, setOrderFormData] = useState<AddFundsOrderFilters>({
    [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: '',
    [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: ''
  });
  const [orderData, setOrderData] = useState<AddFundsToTheWalletOrder>({
    [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: 0,
    [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: PAYMENT_METHODS.EXTERNAL_BANK_TRANSFER_ACCESS
  });
  const [orderResponseData, setOrderResponseData] = useState<AddFundsToTheWalletOrderResponse>();
  const [step, setStep] = useState<ADD_FUNDS_TO_THE_WALLET_STEPS>(ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_FORM);

  switch (step) {
    case ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_FORM:
      return (
        <AddingFundsOrderForm
          onClose={handleClose}
          onSubmit={({
            formDataProp,
            orderDataProp
          }: {
            formDataProp: AddFundsOrderFilters;
            orderDataProp: AddFundsToTheWalletOrder;
          }) => {
            setOrderFormData(formDataProp);
            setOrderData(orderDataProp);
            setStep(ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_SUMMARY);
          }}
          initialValues={orderFormData}
        />
      );
    case ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_SUMMARY:
      return (
        <AddingFundsOrderSummary
          addFundsOrderData={orderData}
          onSubmit={() => {
            handleCreateAnOrder({
              onSuccess: (responseData: AddFundsToTheWalletOrderResponse) => {
                setOrderResponseData(responseData);
                updateCreditsHistory();
                updateClientBalance();
                setStep(ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_CONFIRMATION);
              },
              orderData: {
                creditAmount: {
                  value: orderData.amount
                },
                method: orderData[ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]
              }
            });
          }}
          onClose={() => {
            setStep(ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_FORM);
          }}
          loading={createAnOrderLoading}
          error={createAnOrderError}
        />
      );
    case ADD_FUNDS_TO_THE_WALLET_STEPS.ORDER_CONFIRMATION:
      if (orderResponseData) {
        return (
          <AddingFundsOrderConfirmation
            orderDetails={{
              transferAmount: orderData.amount,
              ...orderResponseData
            }}
            onClose={handleClose}
          />
        );
      }
      return null;
    default:
      return null;
  }
};

export default memo(AddFundsToYourWallet);
